<template>
  <b-overlay :show="overlay" rounded="sm">
    <div style="display:inline-block;width:100%;overflow-y:auto;">
      <ul class="timeline-horizontal">
        <li
          v-for="(item, index) in data"
          :key="index"
          class="timeline-item"
          :class="{ active: item.text == value.text }"
        >
          <b-button @click="timelineClick(item)" class="timeline-badge primary">
            <i class="glyphicon glyphicon-check"></i> {{ item.text }}
          </b-button>
        </li>
      </ul>
    </div>
  </b-overlay>
</template>
<script>
export default {
  name: "time-line",
  props: {
    data: {
      type: Array,
      default: () => [],
      description: "Table data"
    },
    value: {
      type: Object,
      default: () => {
        return {
          text: ""
        };
      }
    }
  },
  data() {
    return {
      overlay: false
    };
  },
  methods: {
    timelineClick(item) {
      this.$emit("input", item);
      this.$emit("timelineClick", item);
    }
  }
};
</script>
